import { ICrewConnection, IFlight, IFullFlight, IGroundEvent, IGroundTimeInterval } from "@vmosolutions/oc-interfaces";
import { TimelineGL } from "src/pages/FlightTimeline/gl/TimelineGL";

import {
  IAircraftFlights,
  IAircraftSortOption,
  IFocusedEvents,
  InteractiveState,
  ITimeIntervalLoaded,
  ITimelineGLInstance,
} from "../../reducers/FlightTimelineReducer";
import { IGetUnassignedAircraftFlights, IGotUpdatedFlight } from "./FlightData.Actions";
export enum Type {
  TIMELINE_ADD_FLIGHT_DATA = "TIMELINE_ADD_FLIGHT_DATA",
  TIMELINE_AIRCRAFT_LOADED = "TIMELINE_AIRCRAFT_LOADED",
  TIMELINE_NUM_AIRCRAFTS = "TIMELINE_NUM_AIRCRAFTS",
  TIMELINE_SET_AIRCRAFT_FILTERS = "TIMELINE_SET_AIRCRAFT_FILTERS",
  TIMELINE_SET_AIRCRAFT_SORT = "TIMELINE_SET_AIRCRAFT_SORT",
  TIMELINE_ADD_EDIT_FLIGHT = "TIMELINE_ADD_EDIT_FLIGHT",
  TIMELINE_REMOVE_EDIT_FLIGHT = "TIMELINE_REMOVE_EDIT_FLIGHT",
  TIMELINE_ISDIRTY_EDIT_FLIGHT = "TIMELINE_ISDIRTY_EDIT_FLIGHT",
  // UPDATE_SELECTED_FLIGHT = 'UPDATE_SELECTED_FLIGHT',
  TIMELINE_GOT_UPDATED_FLIGHT = "TIMELINE_GOT_UPDATED_FLIGHT",
  TIMELINE_FLIGHT_DATA_LOADING = "TIMELINE_FLIGHT_DATA_LOADING",
  TIMELINE_LOADED_DATA_INTERVAL = "TIMELINE_LOADED_DATA_INTERVAL",
  TIMELINE_DELETE_FLIGHT = "TIMELINE_DELETE_FLIGHT",
  TIMELINE_CANCEL_FLIGHT = "TIMELINE_CANCEL_FLIGHT",
  TIMELINE_GET_UNASSIGNED_AIRCRAFT_FLIGHTS = "TIMELINE_GET_UNASSIGNED_AIRCRAFT_FLIGHTS",
  TIMELINE_UPDATE_HOVERED_FLIGHT = "TIMELINE_UPDATE_HOVERED_FLIGHT",
  TIMELINE_SET_INTERACTIVE_STATE = "TIMELINE_SET_INTERACTIVE_STATE",
  TIMELINE_SET_IS_FLIGHT_CONTEXT_OPEN = "TIMELINE_SET_IS_FLIGHT_CONTEXT_OPEN",
  TIMELINE_SET_SELECTED_EVENTS = "TIMELINE_SET_SELECTED_EVENTS",
  TIMELINE_SET_FOCUSED_EVENTS = "TIMELINE_SET_FOCUSED_EVENTS",
  TIMELINE_SET_SELECTED_DAY = "TIMELINE_SET_SELECTED_DAY",
  TIMELINE_SET_SELECTED_AIRCRAFT = "TIMELINE_SET_SELECTED_AIRCRAFT",
  TIMELINE_SET_BULK_ASSIGNMENT_MODE = "TIMELINE_SET_BULK_ASSIGNMENT_MODE",
  TIMELINE_UPDATE_HOVERED_TIME = "TIMELINE_UPDATE_HOVERED_TIME",
  TIMELINE_SET_USER_SET_SCALE = "TIMELINE_SET_USER_SET_SCALE",
  TIMELINE_AIRCRAFT_ROW_SETTINGS = "TIMELINE_AIRCRAFT_ROW_SETTINGS",
  TIMELINE_HOVERED_GROUND_TIME_INTERVAL = "TIMELINE_HOVERED_GROUND_TIME_INTERVAL",
  TIMELINE_SET_CREW_CONNECTIONS = "TIMELINE_SET_CREW_CONNECTIONS",
  TIMELINE_SET_TIMELINEGL = "TIMELINE_SET_TIMELINEGL",
  TIMELINE_SET_IS_AIRCRAFT_CONTEXT_OPEN = "TIMELINE_SET_IS_AIRCRAFT_CONTEXT_OPEN",
  TIMELINE_SET_AIRCRAFT_CONTEXT_ID = "TIMELINE_SET_AIRCRAFT_CONTEXT_ID",
  TIMELINE_APPLY_QUICK_FILTER = "TIMELINE_APPLY_QUICK_FILTER",
  TIMELINE_CLEAR_QUICK_FILTER = "TIMELINE_CLEAR_QUICK_FILTER",
  TIMELINE_SET_QUICK_FILTER_ORDER = "TIMELINE_SET_QUICK_FILTER_ORDER",
}

export interface IAddFlightData {
  type: Type.TIMELINE_ADD_FLIGHT_DATA;
  flightData: IAircraftFlights;
  appendData?: boolean;
}

export interface IFlightChunkDone {
  type: Type.TIMELINE_AIRCRAFT_LOADED;
}

export interface ISetAircraftFilters {
  type: Type.TIMELINE_SET_AIRCRAFT_FILTERS;
  aircraftFilters: string[];
}

export interface ISetAircraftSort {
  type: Type.TIMELINE_SET_AIRCRAFT_SORT;
  aircraftSort: IAircraftSortOption;
}

export interface INumFlightChunks {
  type: Type.TIMELINE_NUM_AIRCRAFTS;
  numAircrafts: number;
}

export interface IAddSelectedFlight {
  type: Type.TIMELINE_ADD_EDIT_FLIGHT;
  flightData: IFullFlight;
}

export interface IRemoveSelectedFlight {
  type: Type.TIMELINE_REMOVE_EDIT_FLIGHT;
  flightId: string;
}

export interface IIsDirtySelectedFlight {
  type: Type.TIMELINE_ISDIRTY_EDIT_FLIGHT;
  windowId: string;
  isDirty: boolean;
}

export interface IFlightDataLoading {
  type: Type.TIMELINE_FLIGHT_DATA_LOADING;
  interval: string;
  loaded: boolean;
}

export interface ISetTimelineLoadedDataInterval {
  type: Type.TIMELINE_LOADED_DATA_INTERVAL;
  interval: ITimeIntervalLoaded;
}

export interface IDeleteFlight {
  type: Type.TIMELINE_DELETE_FLIGHT;
}
export interface ICancelFlight {
  type: Type.TIMELINE_CANCEL_FLIGHT;
}

export interface ISetInteractiveState {
  type: Type.TIMELINE_SET_INTERACTIVE_STATE;
  windowId: string;
  state: InteractiveState;
}

export interface ISetIsFlightContextOpen {
  type: Type.TIMELINE_SET_IS_FLIGHT_CONTEXT_OPEN;
  isOpen: boolean;
  windowId: string;
}

export interface ISetSelectedFlights {
  type: Type.TIMELINE_SET_SELECTED_EVENTS;
  selectedEvents: (IFlight | IGroundEvent)[];
}

export interface ISetFocusedFlights {
  type: Type.TIMELINE_SET_FOCUSED_EVENTS;
  focusedEvents: IFocusedEvents;
}

export interface IUpdateHoveredFlight {
  type: Type.TIMELINE_UPDATE_HOVERED_FLIGHT;
  hoveredFlight: IFlight | IGroundEvent;
}

export interface ISetSelectedDay {
  type: Type.TIMELINE_SET_SELECTED_DAY;
  /** Flight display (mosaic) window the day selection belongs to. */
  windowId: string;
  selectedDay: Date;
}

export interface ISetSelectedAircraft {
  type: Type.TIMELINE_SET_SELECTED_AIRCRAFT;
  /** Window the selection belongs to: a flight display, or another window with its own aircraft picker. */
  windowId: string;
  selectedAircraft: string[];
}
export interface ISetBulkAssignmentMode {
  type: Type.TIMELINE_SET_BULK_ASSIGNMENT_MODE;
  /** Flight display (mosaic) window bulk assignment mode belongs to. */
  windowId: string;
  selectedDay: Date;
  selectedAircraft: string[];
}

export interface IUpdateHoveredTime {
  type: Type.TIMELINE_UPDATE_HOVERED_TIME;
  hoveredTime: number;
}

export interface ISetUserSetScale {
  type: Type.TIMELINE_SET_USER_SET_SCALE;
  userSetScale: number[];
}

export interface ISetAircraftRowSetting {
  type: Type.TIMELINE_AIRCRAFT_ROW_SETTINGS;
  rowPercentage: number;
}

export interface ISetHoveredGroundTimeInterval {
  type: Type.TIMELINE_HOVERED_GROUND_TIME_INTERVAL;
  interval: IGroundTimeInterval;
}

export interface ISetCrewConnections {
  type: Type.TIMELINE_SET_CREW_CONNECTIONS;
  windowId: string;
  connections: ICrewConnection[];
}

export interface ISetTimelineGLs {
  type: Type.TIMELINE_SET_TIMELINEGL;
  timelineGLs: ITimelineGLInstance[];
}

export interface ISetIsAircraftContextOpen {
  type: Type.TIMELINE_SET_IS_AIRCRAFT_CONTEXT_OPEN;
  isOpen: boolean;
  windowId: string;
}

export interface ISetAircraftContextId {
  type: Type.TIMELINE_SET_AIRCRAFT_CONTEXT_ID;
  aircraftId: string | null;
  windowId: string;
  initialTab?: string;
}

/**
 * Apply the quick filter to a fixed set of aircraft. The set is a snapshot taken when the user applies it, not a
 * live view of the selection, so clicking rows afterwards cannot make them disappear from under the user.
 */
export interface IApplyQuickFilter {
  type: Type.TIMELINE_APPLY_QUICK_FILTER;
  /** Flight display (mosaic) window the quick filter belongs to. */
  windowId: string;
  aircraftIds: string[];
}

/** Stop filtering this window and show every aircraft again. The aircraft selection is untouched. */
export interface IClearQuickFilter {
  type: Type.TIMELINE_CLEAR_QUICK_FILTER;
  /** Flight display (mosaic) window the quick filter belongs to. */
  windowId: string;
}

/**
 * Custom vertical order for the filtered aircraft while the quick filter is applied ("free mode"), set by dragging
 * aircraft rows. null means follow the normal aircraft sort.
 */
export interface ISetQuickFilterOrder {
  type: Type.TIMELINE_SET_QUICK_FILTER_ORDER;
  /** Flight display (mosaic) window the quick filter belongs to. */
  windowId: string;
  order: string[] | null;
}

export type Action =
  | ICancelFlight
  | IGotUpdatedFlight
  | IAddFlightData
  | IFlightChunkDone
  | ISetAircraftFilters
  | ISetAircraftSort
  | INumFlightChunks
  | IAddSelectedFlight
  | IRemoveSelectedFlight
  | IIsDirtySelectedFlight
  | IFlightDataLoading
  | ISetTimelineLoadedDataInterval
  | IDeleteFlight
  | IGetUnassignedAircraftFlights
  | IUpdateHoveredFlight
  | ISetInteractiveState
  | ISetIsFlightContextOpen
  | ISetSelectedFlights
  | ISetFocusedFlights
  | ISetSelectedDay
  | ISetSelectedAircraft
  | ISetBulkAssignmentMode
  | IUpdateHoveredTime
  | ISetUserSetScale
  | ISetAircraftRowSetting
  | ISetHoveredGroundTimeInterval
  | ISetCrewConnections
  | ISetTimelineGLs
  | ISetIsAircraftContextOpen
  | ISetAircraftContextId
  | IApplyQuickFilter
  | IClearQuickFilter
  | ISetQuickFilterOrder;

export const setHoveredEvent = (hoveredFlight: IFlight | IGroundEvent): IUpdateHoveredFlight => {
  return { type: Type.TIMELINE_UPDATE_HOVERED_FLIGHT, hoveredFlight };
};

export const setInteractiveState = (state: InteractiveState, windowId: string): ISetInteractiveState => {
  return { type: Type.TIMELINE_SET_INTERACTIVE_STATE, state, windowId };
};

export const setIsFlightContextOpen = (isOpen: boolean, windowId: string): ISetIsFlightContextOpen => {
  return { type: Type.TIMELINE_SET_IS_FLIGHT_CONTEXT_OPEN, isOpen, windowId };
};

export const setSelectedEvents = (selectedEvents: (IFlight | IGroundEvent)[]): ISetSelectedFlights => {
  return { type: Type.TIMELINE_SET_SELECTED_EVENTS, selectedEvents };
};

export const setFocusedEvents = (focusedEvents: IFocusedEvents): ISetFocusedFlights => {
  return { type: Type.TIMELINE_SET_FOCUSED_EVENTS, focusedEvents };
};

export const setAircraftFilters = (aircraftFilters: string[]): ISetAircraftFilters => {
  return {
    type: Type.TIMELINE_SET_AIRCRAFT_FILTERS,
    aircraftFilters,
  };
};

export const setAircraftSort = (aircraftSort: IAircraftSortOption): ISetAircraftSort => {
  return {
    type: Type.TIMELINE_SET_AIRCRAFT_SORT,
    aircraftSort,
  };
};

export const setSelectedDay = (selectedDay: Date, windowId: string): ISetSelectedDay => {
  return { type: Type.TIMELINE_SET_SELECTED_DAY, selectedDay, windowId };
};

// Aircraft selection is per window: two flight displays side by side each keep their own (ENG-715).
export const setSelectedAircraft = (selectedAircraft: string[], windowId: string): ISetSelectedAircraft => {
  return { type: Type.TIMELINE_SET_SELECTED_AIRCRAFT, selectedAircraft, windowId };
};

export const setBulkAssignmentMode = (
  selectedDay: Date,
  selectedAircraft: string[],
  windowId: string
): ISetBulkAssignmentMode => {
  return {
    type: Type.TIMELINE_SET_BULK_ASSIGNMENT_MODE,
    selectedDay,
    selectedAircraft,
    windowId,
  };
};

export const setHoveredTime = (hoveredTime: number): IUpdateHoveredTime => {
  return { type: Type.TIMELINE_UPDATE_HOVERED_TIME, hoveredTime };
};

export const setLoadedDataInterval = (interval: ITimeIntervalLoaded): ISetTimelineLoadedDataInterval => {
  return {
    type: Type.TIMELINE_LOADED_DATA_INTERVAL,
    interval,
  };
};

export const setUserSetScale = (userSetScale: number[]): ISetUserSetScale => {
  return { type: Type.TIMELINE_SET_USER_SET_SCALE, userSetScale };
};

export const setAircraftRowSettings = (rowPercentage: number): ISetAircraftRowSetting => {
  return { type: Type.TIMELINE_AIRCRAFT_ROW_SETTINGS, rowPercentage };
};

export const removeEditFlightWindow = (flightId: string): IRemoveSelectedFlight => {
  return { type: Type.TIMELINE_REMOVE_EDIT_FLIGHT, flightId };
};

export const setHoveredGroundTimeInterval = (interval: IGroundTimeInterval): ISetHoveredGroundTimeInterval => {
  return { type: Type.TIMELINE_HOVERED_GROUND_TIME_INTERVAL, interval };
};

export const setCrewConnections = (connections: ICrewConnection[], windowId: string): ISetCrewConnections => {
  return { type: Type.TIMELINE_SET_CREW_CONNECTIONS, connections, windowId };
};

export const setTimelineGLs = (timelineGLs: ITimelineGLInstance[]): ISetTimelineGLs => {
  return { type: Type.TIMELINE_SET_TIMELINEGL, timelineGLs };
};

export const setIsAircraftContextOpen = (isOpen: boolean, windowId: string): ISetIsAircraftContextOpen => {
  return { type: Type.TIMELINE_SET_IS_AIRCRAFT_CONTEXT_OPEN, isOpen, windowId };
};

export const setAircraftContextId = (
  aircraftId: string | null,
  windowId: string,
  initialTab?: string
): ISetAircraftContextId => {
  return { type: Type.TIMELINE_SET_AIRCRAFT_CONTEXT_ID, aircraftId, windowId, initialTab };
};

// Aircraft quick filter (ENG-715). Temporary, in-memory only - never persisted. The aircraft it shows are the
// window's selected aircraft (setSelectedAircraft); only whether the filter is applied and the free-mode order are
// held per flight display window here.
export const applyQuickFilter = (aircraftIds: string[], windowId: string): IApplyQuickFilter => {
  return { type: Type.TIMELINE_APPLY_QUICK_FILTER, aircraftIds, windowId };
};

export const clearQuickFilter = (windowId: string): IClearQuickFilter => {
  return { type: Type.TIMELINE_CLEAR_QUICK_FILTER, windowId };
};

export const setQuickFilterOrder = (order: string[] | null, windowId: string): ISetQuickFilterOrder => {
  return { type: Type.TIMELINE_SET_QUICK_FILTER_ORDER, order, windowId };
};
